import axios from 'axios';

import {
  list,
  id,
  detail,
} from './actions';

import conf from './../../config/config.js';

/**
 * 改造工事費用算定件名一覧 取得
 *
 * @param {object} conditions 検索条件
 * @return {function} edux thunk function
 */
const getList = (conditions) => {
  console.log('改造工事費用算定件名 一覧 取得...');
  return async (dispatch) => {
    const body = {
      conditions: conditions,
    };

    const ret = await axios.post(conf.API_URL + 'DrSideKoziCost/list', body);

    const data = ret.data.body.data ?? [];
    dispatch(list(data));
    return ret;
  };
};

/**
 * 改造工事費用算定件名一覧 クリア
 * @return {function} Redux thunk function
 */
const clearList = () => {
  return (dispatch) => {
    dispatch(list(null));
  };
};

/**
 * 改造工事費用算定件名 Id設定
 * @param {string} recordId
 * @return {function} Redux thunk function
 */
const setId = (recordId) => {
  return (dispatch) => {
    dispatch(id(recordId));
  };
};

/**
 * 改造工事費用算定件名 Idクリア
 * @return {function} Redux thunk function
 */
const clearId = () => {
  return (dispatch) => {
    dispatch(id(null));
  };
};

const getDetail = (id) => {
  console.log('改造工事費用算定件名 詳細 取得...');
  return async (dispatch, getState) => {
    const body = {
      conditions: {Id: id},
    };
    const ret = await axios.post(conf.API_URL + 'DrSideKoziCost/detail', body);
    const data = ret.data.body.data ? ret.data.body.data : null;
    dispatch(detail(data));
    return ret;
  };
};

const clearDetail = () => {
  console.log('改造工事費用算定件名 詳細 クリア...');
  return (dispatch) => {
    dispatch(detail(null));
  };
};

/**
 * 改造工事費用算定件名 削除
 * @param {{Id: string, LastModifiedDate: string}[]} deleteTargets
 * @return {function} Redux thunk function
 */
const deleteItems = (deleteTargets) => {
  console.log('改造工事費用算定件名 削除...');
  return async (dispatch) => {
    const body = {
      conditions: deleteTargets,
    };

    const ret = await axios.post(conf.API_URL + 'DrSideKoziCost/delete', body);
    return ret;
  };
};

/**
 * 改造工事費用算定件名 一時保存。
 * 保存が成功した場合、レスポンス(初期表示時の取得処理と同じ形式)をdetail stateに反映する
 * (画面側はこのレスポンスで再描画する)。
 * @param {object} title 保存対象の改造工事費用算定件名(フォームの値そのもの。
 *   DrSideKoziCostResults__r/DrSideKoziTargetPoles__r(その中のDrSideKoziTargetPoleDetails__r)を含む)
 * @return {function} Redux thunk function
 */
const saveItem = (title) => {
  console.log('改造工事費用算定件名 一時保存...');
  return async (dispatch) => {
    const body = {
      title: title,
    };
    const ret = await axios.post(conf.API_URL + 'DrSideKoziCost/save', body);

    // 成功時のみstateを更新
    if (ret.data.body.errorCode === '00000') {
      dispatch(detail(ret.data.body.data ?? null));
    }

    return ret;
  };
};

/**
 * 改造工事費用算定件名 確定。
 * 確定が成功した場合、レスポンス(初期表示時の取得処理と同じ形式)をdetail stateに反映する
 * (画面側はこのレスポンスで再描画する)。
 * @param {object} title 保存対象の改造工事費用算定件名(フォームの値そのもの)
 * @return {function} Redux thunk function
 */
const confirmItem = (title) => {
  console.log('改造工事費用算定件名 確定...');
  return async (dispatch) => {
    const body = {
      title: title,
    };
    const ret = await axios.post(conf.API_URL + 'DrSideKoziCost/confirm', body);

    // 成功時のみstateを更新
    if (ret.data.body.errorCode === '00000') {
      dispatch(detail(ret.data.body.data ?? null));
    }

    return ret;
  };
};

export default {
  getList,
  clearList,
  setId,
  clearId,
  getDetail,
  clearDetail,
  deleteItems,
  saveItem,
  confirmItem,
};
